var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0718 14.6667H12.9873C6.82287 14.0756 1.9251 9.17778 1.33398 3.09778C1.33398 2.84444 1.41843 2.59111 1.58732 2.33778C1.75621 2.08444 2.00954 2 2.34732 2H4.71176C5.21843 2 5.55621 2.33778 5.7251 2.76L6.4851 5.04C6.65398 5.46222 6.4851 5.88444 6.23176 6.13778L5.89398 6.47556C5.55621 6.81333 5.55621 7.23556 5.80954 7.57333C6.56954 8.67111 7.2451 9.34667 8.42732 10.1911C8.7651 10.4444 9.27176 10.36 9.52509 10.1067L9.86287 9.76889C10.1162 9.51556 10.5384 9.34667 10.9607 9.51556L13.2407 10.2756C13.6629 10.4444 14.0007 10.8667 14.0007 11.2889V13.6533C14.0007 13.9911 13.9162 14.2444 13.6629 14.4133C13.494 14.5822 13.2407 14.6667 13.0718 14.6667Z",
    fill: "#5096E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 5C8.66602 5 9.7804 5.11438 10.3327 5.66667C10.885 6.21895 10.9993 7.33333 10.9993 7.33333",
    stroke: "#5096E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 1.99999C8.66602 1.99999 11.1933 1.86061 12.666 3.33337C14.1388 4.80613 13.9993 7.33332 13.9993 7.33332",
    stroke: "#5096E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.3bae1a6c14a3ee81ab4acdf3f9e5845c.svg";
export { ForwardRef as ReactComponent };